import React, { useState, useEffect } from 'react';

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

// ========== Inline SVG Icons ==========
// Kono external dependency chara icon bebohar korar jonno.
const AddCircleIcon = ({ size = 22, color = 'currentColor' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
  </svg>
);

const CloseIcon = ({ size = 24, color = 'currentColor' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const FileUploadIcon = ({ size = 40, color = "#007bff" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="17 8 12 3 7 8"></polyline>
        <line x1="12" y1="3" x2="12" y2="15"></line>
    </svg>
);

const SuccessIcon = ({ size = 60, color = "#28a745" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
);


// ========== STYLES (Inline CSS Objects) ==========
const styles = {
  triggerButton: {
    display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', fontSize: '16px', fontWeight: 'bold', color: '#ffffff', backgroundColor: '#007bff', border: 'none', borderRadius: '8px', cursor: 'pointer', transition: 'background-color 0.3s ease',
  },
  modalOverlay: {
    position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.65)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000,
  },
  modalContent: {
    backgroundColor: '#ffffff', padding: '2rem', borderRadius: '10px', boxShadow: '0 5px 20px rgba(0,0,0,0.3)', width: '90%', maxWidth: '550px', maxHeight: '90vh', overflowY: 'auto', position: 'relative', animation: 'fadeIn 0.3s ease-out',
  },
  modalHeader: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e5e5e5', paddingBottom: '1rem', marginBottom: '1.5rem',
  },
  modalTitle: { margin: 0, fontSize: '1.5rem', color: '#333' },
  closeButton: {
    background: 'transparent', border: 'none', fontSize: '1.75rem', cursor: 'pointer', color: '#888', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  formGroup: { marginBottom: '1.25rem' },
  label: { display: 'block', fontWeight: '600', marginBottom: '8px', color: '#4b4f56', textAlign: 'left' },
  input: {
    width: '100%', padding: '12px', fontSize: '1rem', border: '1px solid #ccd0d5', borderRadius: '6px', boxSizing: 'border-box', transition: 'border-color 0.2s',
  },
  textarea: {
    width: '100%', padding: '12px', fontSize: '1rem', border: '1px solid #ccd0d5', borderRadius: '6px', boxSizing: 'border-box', resize: 'vertical', minHeight: '100px',
  },
  // **FIXED**: Using Flexbox to correctly align items
  fileInputContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px dashed #007bff', 
    borderRadius: '6px', 
    padding: '2rem', 
    textAlign: 'center', 
    cursor: 'pointer', 
    backgroundColor: '#f8f9fa',
  },
  fileInputText: { color: '#555', fontWeight: '500', margin: '10px 0 0 0' },
  fileTagsContainer: {
    marginTop: '1rem', display: 'flex', flexWrap: 'wrap', gap: '10px',
  },
  fileTag: {
    display: 'flex', alignItems: 'center', backgroundColor: '#e7f3ff', color: '#0056b3', padding: '6px 12px', borderRadius: '16px', fontSize: '0.875rem', fontWeight: '500',
  },
  removeTagButton: {
    marginLeft: '10px', cursor: 'pointer', fontWeight: 'bold', color: '#0056b3', background: 'none', border: 'none', fontSize: '1rem'
  },
  submitButton: {
    width: '100%', padding: '14px', fontSize: '1rem', fontWeight: 'bold', color: '#ffffff', backgroundColor: '#3498DB', border: 'none', borderRadius: '6px', cursor: 'pointer', transition: 'background-color 0.3s ease',
  },
  submitButtonDisabled: {
    backgroundColor: '#94d3a2', cursor: 'not-allowed',
  },
  successMessage: {
    textAlign: 'center', padding: '2rem 0'
  },
  successText: {
    fontSize: '1.2rem', color: '#333', marginTop: '1rem'
  }
};

// ========== The Modal Component ==========
const AddHistoryModal = ({ isOpen, onClose, id, onHistoryAdded }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState('');
  const [files, setFiles] = useState([]);
  const [status, setStatus] = useState('idle'); // 'idle', 'submitting', 'success'
  const [error, setError] = useState('');
  const [historyStatus, setHistoryStatus] = useState(''); // New state for status field

  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        setTitle('');
        setDescription('');
        setDate('');
        setFiles([]);
        setStatus('idle');
        setError('');
        setHistoryStatus(''); // Reset status field
      }, 300);
    }
  }, [isOpen]);

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setFiles(prevFiles => [...prevFiles, ...newFiles]);
  };

  const handleRemoveFile = (fileNameToRemove) => {
    setFiles(prevFiles => prevFiles.filter(file => file.name !== fileNameToRemove));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status === 'submitting') return;
    setStatus('submitting');
    setError('');
    try {
      const formData = new FormData();
      formData.append('title', title);
      formData.append('description', description);
      formData.append('date', date);
      formData.append('historyStatus', historyStatus); // Add status to formData
      files.forEach(file => formData.append('files', file));

      // Get token from localStorage
      const user = JSON.parse(localStorage.getItem('user'));
      const token = user?.token;

      const response = await fetch(`${BASE_URL}/api/cases/${id}/history`, {
        method: 'POST',
        body: formData,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || 'Failed to add history');
      }
      setStatus('success');
      if (onHistoryAdded) onHistoryAdded(); // Call refresh after success
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (err) {
      setError(err.message || 'Failed to add history');
      setStatus('idle');
    }
  };
  
  if (!isOpen) {
    return null;
  }

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>Add New History</h2>
          <button style={styles.closeButton} onClick={onClose} disabled={status === 'submitting'}>
            <CloseIcon />
          </button>
        </div>
     
        {status === 'success' ? (
          <div style={styles.successMessage}>
            <SuccessIcon />
            <p style={styles.successText}>History Added Successfully!</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={styles.formGroup}>
              <label htmlFor="title" style={styles.label}>Title</label>
              <input type="text" id="title" value={title} onChange={(e) => setTitle(e.target.value)} style={styles.input} placeholder="Enter a short title" required />
            </div>
            
            <div style={styles.formGroup}>
              <label htmlFor="description" style={styles.label}>Description</label>
              <textarea id="description" value={description} onChange={(e) => setDescription(e.target.value)} style={styles.textarea} placeholder="Describe the details" required></textarea>
            </div>
            
            <div style={styles.formGroup}>
              <label htmlFor="date" style={styles.label}>Date</label>
              <input type="date" id="date" value={date} onChange={(e) => setDate(e.target.value)} style={styles.input} required />
            </div>

            {/* Status Field as Text Input */}
            <div style={styles.formGroup}>
              <label htmlFor="historyStatus" style={styles.label}>Status</label>
              <input
                type="text"
                id="historyStatus"
                value={historyStatus}
                onChange={e => setHistoryStatus(e.target.value)}
                style={styles.input}
                placeholder="Enter status"
                required
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Attach Files</label>
              <label htmlFor="files" style={styles.fileInputContainer}>
                <FileUploadIcon />
                <p style={styles.fileInputText}>Click to browse or drag and drop files</p>
              </label>
              <input type="file" id="files" multiple onChange={handleFileChange} style={{ display: 'none' }} />
              <div style={styles.fileTagsContainer}>
                {files.map((file) => (
                  <div key={file.name} style={styles.fileTag}>
                    {file.name}
                    <button type="button" style={styles.removeTagButton} onClick={() => handleRemoveFile(file.name)}>&times;</button>
                  </div>
                ))}
              </div>
            </div>
            {error && <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>}
            <button
              type="submit"
              style={{ ...styles.submitButton, ...(status === 'submitting' && styles.submitButtonDisabled) }}
              disabled={status === 'submitting'}
            >
              {status === 'submitting' ? 'Saving...' : 'Save History'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};


// ========== Example Usage in App Component ==========
export default function AddHistory({ id, onHistoryAdded }) {
  const [isModalOpen, setModalOpen] = useState(false);

  const keyframes = `
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(-20px) scale(0.95); }
      to { opacity: 1; transform: translateY(0) scale(1); }
    }
  `;

  const handleClose = () => setModalOpen(false);

  return (
    <div style={{ padding: '0rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <style>{keyframes}</style>
   

   
        <div onClick={() => setModalOpen(true)}> 
          <AddCircleIcon />
        </div>
        
   

      <AddHistoryModal 
        isOpen={isModalOpen} 
        id={id}
        onClose={handleClose} 
        onHistoryAdded={onHistoryAdded}
      />
    </div>
  );
}
